import type { VueConstructor } from 'vue';
import Vue from 'vue';
// @ts-ignore
import TestimonialsQuery from '../apollo/testimonials.gql';
import { updateTestimonial } from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/utils';
import type { Maybe, Testimonial, TestimonialAuthor } from '~/types/graphql';
import ApproveTestimonialForPublicPortfolioCurrentUser from '~/apollo/mutations/Portfolio/ApproveTestimonialForPublicPortfolioCurrentUser.mutations';
import { testimonialStates } from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/constants';

const approveTestimonialMixin = Vue.extend({
  name: 'ApproveTestimonialMixin',
  apollo: {
    testimonials: {
      query: TestimonialsQuery,
      update: data => data.publicPortfolioCurrentUser.testimonials,
    },
  },
  data(): { testimonials: Testimonial[] } {
    return {
      testimonials: [],
    };
  },
  computed: {
    testimonial(): Testimonial | undefined {
      return this.testimonials.find(t => t.id === this.$route.query['testimonial-id']);
    },
    actionNeededTestimonial(): Testimonial | undefined {
      const isValid =
        !!this.testimonial && testimonialStates.ACTION_NEEDED_TESTIMONIAL_STATES.includes(this.testimonial.state);
      return isValid ? this.testimonial : undefined;
    },
    hasError(): boolean {
      return (
        !!this.actionNeededTestimonial &&
        testimonialStates.FAILED_TESTIMONIAL_STATES.includes(this.actionNeededTestimonial.state)
      );
    },
    isApproved(): boolean {
      return !!this.testimonial && testimonialStates.APPROVED_TESTIMONIAL_STATES.includes(this.testimonial.state);
    },
  },
  methods: {
    getAuthorName(author: TestimonialAuthor): string {
      if (author.firstname && author.lastname) {
        return `${author?.firstname} ${author?.lastname}`;
      } else {
        return author?.firstname || author?.lastname || '';
      }
    },
    async approveTestimonial(data: {
      author?: { linkedinUrl: Maybe<string> };
      confirmationScreenshotSignedId?: Maybe<string>;
    }): Promise<void> {
      if (this.actionNeededTestimonial) {
        const { id } = this.actionNeededTestimonial;

        await this.$apollo.mutate({
          mutation: ApproveTestimonialForPublicPortfolioCurrentUser,
          variables: {
            input: {
              id,
              ...data,
            },
          },
          update: (
            store,
            {
              data: {
                approveTestimonialForPublicPortfolioCurrentUser: { state },
              },
            },
          ) => {
            updateTestimonial(store, id, { state });
          },
        });
        await this.$router.push(
          `?dynamic_modal=${this.$constants.dynamicModals.PUBLIC_PORTFOLIO_APPROVE_TESTIMONIAL_SUCCESS_MODAL}`,
        );
      }
    },
    logEvent(name: string): void {
      this.$analytics.logEvent('public-portfolio__approve-testimonial', { name });
    },
  },
});

export default approveTestimonialMixin;
export type ApproveTestimonialMixinType = VueConstructor<Vue & InstanceType<typeof approveTestimonialMixin>>;
